export default "__VITE_ASSET__ckuJw1rd__"